module.exports = __webpack_public_path__ + "img/021.14507a0b.png";